<div class="app-container">
  <page-header [title]="'automatic-orders.fork.heading'">
    <ng-container class="back-button">
      <btn
        [label]="'back'"
        [title]="'back' | translate"
        [isBackButton]="true"
        [classes]="['btn-third', 'float-right', 'mr-2']"
        [icon]="'far-arrow-left'"
        [routerLink]="['/purchase-orders']"
      ></btn>
    </ng-container>
  </page-header>

  <div class="page-container d-flex justify-content-center align-items-center">
    <div class="row justify-content-center mt-5">
      <div class="col-xl-5 col-lg-6 col-md-6 mb-4 px-3">
        <div class="card">
          <div class="card-content">
            <div class="d-flex align-items-center mb-3">
              <div>
                <img src="assets/img/purchase-orders-hs-logo.png" alt="" class="company-img" />
              </div>
              <h1 class="ml-3">
                {{ 'automatic-orders.fork.hs.heading' | translate }}
              </h1>
            </div>
            <div>
              {{ 'automatic-orders.fork.hs.desc' | translate }}
            </div>
          </div>
          <div>
            <btn
              [btnType]="'button'"
              [classes]="['btn-first', 'p-3']"
              [routerLink]="'/purchase-order-hs'"
              [label]="'automatic-orders.fork.hs.btn'"
              [title]="'automatic-orders.fork.hs.btn' | translate"
            ></btn>
          </div>
        </div>
      </div>
      <div class="col-xl-5 col-lg-6 col-md-6 mb-4 px-3">
        <div class="card">
          <div class="card-content">
            <div class="d-flex align-items-center mb-3">
              <div>
                <img src="assets/img/purchase-orders-others-logo.png" alt="" class="company-img" />
              </div>
              <h1 class="ml-3">
                {{ 'automatic-orders.fork.other.heading' | translate }}
              </h1>
            </div>
            <div>
              {{ 'automatic-orders.fork.other.desc' | translate }}
            </div>
          </div>
          <div>
            <btn
              [btnType]="'button'"
              [classes]="['btn-third', 'p-3']"
              [routerLink]="'/purchase-order'"
              [label]="'automatic-orders.fork.other.btn'"
              [title]="'automatic-orders.fork.other.btn' | translate"
            ></btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
